import "./SocialLinks.css";
import { Icon } from "@chakra-ui/react";
import { BsGithub, BsLinkedin, BsMailbox } from "react-icons/bs";

const SocialLinks = () => {
    return (
        <div className="SocialLinks">
            <a href="https://www.github.com/mmahtabfar1">
                <Icon color="white" w={"32px"} h={"32px"} margin={"5px"} as={BsGithub}/>
            </a>
            <a href="https://www.linkedin.com/in/mahan-mahtabfar/">
                <Icon color="white" w={"32px"} h={"32px"} margin={"5px"} as={BsLinkedin}/>
            </a>
            <a href="mailto:mmahtabfar1@gmail.com">
                <Icon color="white" w={"32px"} h={"32px"} margin={"5px"} as={BsMailbox}/>
            </a>
        </div>
    );
}

export default SocialLinks;